import { PERSONALISED_APPS_TEAM_TYPES } from './constants.tsx';
import type { TeamType } from './types.tsx';

export const mapUserTeamTypeToTeamType = (team?: string): TeamType | undefined => {
	switch (team) {
		case PERSONALISED_APPS_TEAM_TYPES.softwareDevelopment:
			return PERSONALISED_APPS_TEAM_TYPES.softwareDevelopment;
		case PERSONALISED_APPS_TEAM_TYPES.itSupport:
			return PERSONALISED_APPS_TEAM_TYPES.itSupport;
		default:
			return PERSONALISED_APPS_TEAM_TYPES.marketing;
	}
};
